import ControlsWrapper from 'components/allowances/controls/ControlsWrapper';
import type { AllowancesTable } from 'components/allowances/dashboard/columns';
import Checkbox from 'components/common/Checkbox';
import { useAddress } from 'lib/hooks/page-context/AddressIdentityContext';

interface Props {
  table: AllowancesTable;
}

const GlobalSelectCell = ({ table }: Props) => {
  const { address } = useAddress();

  const selectedRows = table.getSelectedRowModel().flatRows;
  const selectedCount = selectedRows.length;
  const selectableCount = table.getRowModel().flatRows.filter((row) => row.getCanSelect()).length;
  const checked = selectedCount === selectableCount && selectableCount > 0;
  const indeterminate = selectedCount > 0;

  return (
    <ControlsWrapper address={address} overrideDisabled={selectableCount === 0}>
      {(disabled) => (
        <div className="w-fit">
          <Checkbox
            disabled={disabled}
            checked={checked && !disabled}
            indeterminate={indeterminate && !disabled}
            onChange={table.getToggleAllRowsSelectedHandler()}
            iconClassName="max-sm:w-5 max-sm:h-5"
          />
        </div>
      )}
    </ControlsWrapper>
  );
};

export default GlobalSelectCell;
